import { c as _c } from "react/compiler-runtime";
import { TELESALES_API_URL } from "@website/accommodation-ui/constant/addresses";
import { calculateDifferencesNight } from "@website/accommodation-ui/helpers/dateWithCustomFormat";
import { getPassengersAndRoomFromQuery } from "@website/accommodation-ui/helpers/passengers";
import { EmptyStateResponse, TelesalesFromDataType } from "@website/accommodation-ui/tour-empty-state/types";
import { fetcher } from "@website/fetcher/fetcher";
import { useMutation } from "@website/fetcher/use-fetcher";
import { useForm } from "@website/form/hook/form.hooks";
import { USER_TRACKING_EVENTS, WEBENGAGE_EVENTS } from "@website/tracking/tracking.types";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import { addEventToTracking } from "@website/tracking/user";
import { useSnackbar } from "@website/ui/snackbar";
import { getChannel } from "@website/utils/channel/get-channel";
import { daysBetweenDates } from "@website/utils/date-format";
import pick from "lodash-es/pick";
import toNumber from "lodash-es/toNumber";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { object, string } from "yup";
export const useTourTelesales = data => {
  const $ = _c(49);
  const router = useRouter();
  const {
    enqueue
  } = useSnackbar();
  const {
    stDate,
    rtDate,
    origin: city_from,
    dest: city_to,
    passengers,
    calendar_type
  } = router.query;
  const t0 = stDate as string;
  const t1 = rtDate as string;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = calculateDifferencesNight(t0, t1);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const differencesNight = t2;
  let t3;
  if ($[3] !== data || $[4] !== differencesNight) {
    t3 = data?.filter(item => item.stayCount === differencesNight);
    $[3] = data;
    $[4] = differencesNight;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const sameNightSuggestions = t3;
  let t4;
  if ($[6] !== city_from || $[7] !== city_to || $[8] !== data || $[9] !== passengers || $[10] !== rtDate || $[11] !== sameNightSuggestions?.length || $[12] !== stDate) {
    t4 = () => {
      if (Array.isArray(data) && data?.length > 0) {
        addEventToWebengage(WEBENGAGE_EVENTS.TOUR_ST_SUGGESTED, {
          Orgin: city_from,
          Destination: city_to,
          Departure: stDate,
          Return: rtDate,
          passengers,
          suggestions: data.length,
          suggestions_same_night: sameNightSuggestions?.length
        });
      }
    };
    $[6] = city_from;
    $[7] = city_to;
    $[8] = data;
    $[9] = passengers;
    $[10] = rtDate;
    $[11] = sameNightSuggestions?.length;
    $[12] = stDate;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== city_from || $[15] !== city_to || $[16] !== data || $[17] !== differencesNight || $[18] !== passengers || $[19] !== rtDate || $[20] !== sameNightSuggestions || $[21] !== stDate) {
    t5 = [city_from, city_to, data, differencesNight, passengers, rtDate, sameNightSuggestions, stDate];
    $[14] = city_from;
    $[15] = city_to;
    $[16] = data;
    $[17] = differencesNight;
    $[18] = passengers;
    $[19] = rtDate;
    $[20] = sameNightSuggestions;
    $[21] = stDate;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  useEffect(t4, t5);
  let t6;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      mode: "onBlur",
      defaultValues: {
        freeTransferMobileNumber: ""
      },
      validations: object({
        freeTransferMobileNumber: string().required().mobile()
      })
    };
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const {
    control,
    handleSubmit
  } = useForm(t6);
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      mutationFn: _temp2
    };
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const {
    isPending,
    mutateAsync
  } = useMutation(t7);
  let t8;
  if ($[25] !== city_from || $[26] !== city_to || $[27] !== enqueue || $[28] !== mutateAsync || $[29] !== rtDate || $[30] !== stDate) {
    t8 = async data_2 => {
      const timestamp = toNumber(localStorage.getItem("submit-telesales-empty-state"));
      if (Boolean(timestamp) && Date.now() - timestamp <= 10800000) {
        enqueue("\u0634\u0645\u0627\u0631\u0647 \u0634\u0645\u0627 \u0642\u0628\u0644\u0627 \u062B\u0628\u062A \u0634\u062F\u0647 \u0627\u0633\u062A.", "warning", "one-line");
      } else {
        localStorage.setItem("submit-telesales-empty-state", Date.now()?.toString());
        await mutateAsync({
          app: "tour",
          channel: getChannel(),
          checkin: stDate,
          checkout: rtDate,
          city_from,
          city_to,
          city_id: 0,
          description: data_2?.reason || "",
          funnel: "empty_state",
          hotel_id: 0,
          phone: data_2?.freeTransferMobileNumber
        });
        enqueue("\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0634\u0645\u0627 \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u062B\u0628\u062A \u0634\u062F.", "success", "one-line");
      }
    };
    $[25] = city_from;
    $[26] = city_to;
    $[27] = enqueue;
    $[28] = mutateAsync;
    $[29] = rtDate;
    $[30] = stDate;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  const handleSetEvent = t8;
  const FaDate = _temp3;
  let t9;
  if ($[32] !== calendar_type || $[33] !== city_from || $[34] !== city_to || $[35] !== data?.length || $[36] !== differencesNight || $[37] !== passengers || $[38] !== router || $[39] !== rtDate || $[40] !== stDate) {
    t9 = item_0 => {
      router.push({
        pathname: "/[origin]/[dest]",
        query: {
          ...pick(router.query, ["origin", "dest", "passengers", "source", "referrer"]),
          stDate: item_0?.departureDate,
          rtDate: item_0?.returnDate
        }
      }, undefined, {
        shallow: true,
        scroll: true
      });
      addEventToWebengage(WEBENGAGE_EVENTS.TOUR_ST_SUGGESTION_CLICKED, {
        Orgin: city_from,
        Destination: city_to,
        Departure: stDate,
        Return: rtDate,
        passengers,
        suggestions: data?.length,
        isSameNight: item_0?.stayCount === differencesNight
      });
      addEventToTracking(USER_TRACKING_EVENTS.GENERAL_SEARCH, {
        product: "tour",
        origin_city: city_from as string,
        destination_city: city_to as string,
        departure_date: new Date(stDate as string),
        return_departure_date: new Date(rtDate as string),
        search_window: Math.abs(daysBetweenDates(new Date(), stDate)),
        number_of_passengers: getPassengersAndRoomFromQuery(passengers as string).adults + getPassengersAndRoomFromQuery(passengers as string).child,
        number_of_rooms: getPassengersAndRoomFromQuery(passengers as string).rooms?.length,
        search_source: "recommended_page",
        calendar_type: calendar_type as string
      });
    };
    $[32] = calendar_type;
    $[33] = city_from;
    $[34] = city_to;
    $[35] = data?.length;
    $[36] = differencesNight;
    $[37] = passengers;
    $[38] = router;
    $[39] = rtDate;
    $[40] = stDate;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  const redirect = t9;
  let t10;
  if ($[42] !== control || $[43] !== enqueue || $[44] !== handleSetEvent || $[45] !== handleSubmit || $[46] !== isPending || $[47] !== redirect) {
    t10 = {
      redirect,
      FaDate,
      control,
      handleSubmit,
      handleSetEvent,
      enqueue,
      isPending
    };
    $[42] = control;
    $[43] = enqueue;
    $[44] = handleSetEvent;
    $[45] = handleSubmit;
    $[46] = isPending;
    $[47] = redirect;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  return t10;
};
function _temp(t0) {
  const {
    data: data_1
  } = t0;
  return data_1;
}
function _temp2(data_0) {
  return fetcher({
    url: TELESALES_API_URL,
    method: "POST",
    data: data_0
  }).then(_temp);
}
function _temp3(date) {
  const currentDate = new Date(date).toLocaleDateString("fa-IR", {
    day: "2-digit",
    month: "long"
  }) || "";
  return currentDate;
}